// extracted by mini-css-extract-plugin
export default {"card":"FormWrapper-module_card_V6TDyw"};